const controller = "user";

export default {
  controller,
  switchCompany: controller + "/active-company",
};
